<!DOCTYPE html>
<template>
<div class="sign-in">

  <b-card no-body
          class="shadow">
    <h1>Sign in</h1>
    <b-input placeholder="Email address"
             v-model="email">Email address</b-input>
    <b-input placeholder="Password"
             v-model="password"
             type="password">Email address</b-input>
    <b-button variant="primary"
              @click="signIn()">Submit</b-button>
  </b-card>

</div>
</template>

<script>
const firebase = require( '@/firebaseConfig.js' )
export default {
  name: 'SignIn',
  metaInfo() {
    return {
      title: 'SignIn',
      meta: [
        { name: "description", content: "SignIn" },
        { name: "twitter:title", content: "BlueTeam", vmid: 'twitter:title' },
        { name: "og:image", content: "https://getblueteam.com/img/BlueTeamLogo.bb7395fa.png" },
        { name: "twitter:description", content: 'Sign In', vmid: 'twitter:description' },
        { name: "keywords", content: "cybersecurity, talent, fintech, digital health, appsec, IAM, identity management, devsecops, devops, cloud security" }
      ]
    }
  },
  components: {},
  props: {
    next: String
  },
  methods: {
    signIn() {
      this.$root.next = '/dashboard'
      firebase.firebase.auth().signInWithEmailAndPassword( this.email, this.password )
        .then( () => {
          this.$router.push( this.nextDestination )/*.catch( ( error ) => { console.log( error ) } )*/
        } )
        /*.catch( function( error ) {
          console.log( error )
        } );*/
    }
  },
  computed: {
    nextDestination() {
      if ( this.$root.next ) {
        return this.$root.next
      }
      return '/'
    }
  },
  data() {
    return {
      email: null,
      password: null,
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/styles/overrides.scss";

.sign-in {
    display: grid;
    grid-row-gap: 1rem;
    max-width: 1200px;
    margin: 5rem auto;
    color: $primary;
    justify-content: center;

    .card {
        display: grid;
        grid-row-gap: 1rem;
        padding: 3rem;
        justify-content: flex-start;
    }

}
</style>
